import React from "react";

const FormLocalSurface = ({
  formData,
  handleChange,
  inputFocus,
  handleTrimValue,
}) => {
  return (
    <div className="background--warning p-4">
      <div className="row">
        <div className="col-12 position-relative">
          <label htmlFor="LocSurface" className="form-label">
            Surface totale habitable en m²&nbsp;:&nbsp;
            <span className="text-danger">*</span>
          </label>
          <input
            className="form-control page-3-required inputReg getLabel"
            type="text"
            pattern="[0-9.]+"
            name="LocSurface"
            id="LocSurface"
            maxLength={10}
            value={
              formData.ProActivite ===
                "Location meublée courte durée (location touristique)" ||
              formData.ProSurface50 !== "" ||
              formData.ProResidencePrincipale === "Non"
                ? formData.LocSurface || ""
                : (formData.LocSurface = "")
            }
            onChange={handleChange}
            onInput={inputFocus}
            onBlur={handleTrimValue}
            placeholder="ex: 20, 30 ou 30.5 (Les nombres à virgule ne sont pas acceptés)"
            required
            autoComplete="nope"
          />
          <div className="invalid-tooltip">
            Veuillez entrer une surface habitable valide (ex: 30.5)
          </div>
        </div>
      </div>
      <div className="row pb-3 pt-md-0">
        <div className="col-12 mt-3 position-relative">
          <label htmlFor="LocNombrePiece" className="form-label">
            Nombre de pièces principales (hors cuisine / wc / salle de
            bains)&nbsp;:&nbsp;<span className="text-danger">*</span>
          </label>
          <input
            className="form-control page-3-required inputReg getLabel"
            type="text"
            pattern="[0-9]+"
            name="LocNombrePiece"
            id="LocNombrePiece"
            maxLength={5}
            value={formData.LocNombrePiece || ""}
            onChange={handleChange}
            onInput={inputFocus}
            onBlur={handleTrimValue}
            required
            autoComplete="nope"
          />
          <div className="invalid-tooltip">
            Veuillez entrer un nombre de pièces valide
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormLocalSurface;
